import { FC } from 'react';
import { Icon, SmallLoader } from 'learning-panel-components';
import styles from './videoTutorial.module.scss';

const VideoTutorial: FC<VideoTutorialProps> = (props: VideoTutorialProps) => {
    const { onClose, videoUrl, isLoading, onStart, onComplete } = props;

    return (
        <div className={styles['background-wrapper']}>
            <div className={styles['video-tutorial-wrapper']}>
                <div className={styles['top-wrapper']}>
                    <Icon name="cancel" onClick={onClose} className={styles.cancel} />
                </div>
                <div className={styles.video}>
                    {isLoading || !videoUrl ? (
                        <SmallLoader size="85px" />
                    ) : (
                        <video
                            onPlay={() => onStart()}
                            onEnded={() => onComplete()}
                            controls
                            width="100%"
                            controlsList="nodownload"
                        >
                            <source src={videoUrl} />
                        </video>
                    )}
                </div>
            </div>
        </div>
    );
};

interface VideoTutorialProps {
    onClose: Function;
    videoUrl?: string;
    isLoading: boolean;
    onStart: Function;
    onComplete: Function;
    name?: string;
    uuid?: string;
}

export default VideoTutorial;
